<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body,
html,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
}
.massive-h5 .bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.8);
}
.massive-h5 .bg .progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.massive-h5 .bg .el-progress__text {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue